import React from "react";
import { Navigate } from "react-router-dom";

export default function RequestExecutiveMemosPage() {
  return (
    <Navigate
      to="/executive-memos?create=1"
      replace
    />
  );
}
